import { CUSTOMER_JOURNEY_LOGIN_SUCCESS } from './../const';

function action(data, successCallback) {
  return { type: CUSTOMER_JOURNEY_LOGIN_SUCCESS, data, successCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyLoginSuccess.js